import React from 'react'

const InterstReport = () => {
  return (
    <div>InterstReport</div>
  )
}

export default InterstReport